<template>
  <section class="subprograms">
    <Container tag="h2" class="is-centered"
      >Subprogramas de Investigación</Container
    >
    <ContainerLR>
      <div class="subprograms__container-l">
        <ContentL>
          <p>
            El siguiente Programa de investigación del Instituto Geofísico del
            Perú - <b>IGP</b>, comprende los siguientes subprogramas de
            investigación.
          </p>
        </ContentL>
      </div>
      <div class="subprograms__container-r">
        <ContentR>
          <!-- <List>
            <li
              v-for="(subprogram, index) in subprograms"
              :key="index"
              class="program"
            >
              
              <h5 class="program__title"><Icon svg="doubleAngleRight" />{{ subprogram.title }}</h5>
              <Button
                tag="router-link"
                theme="inverted"
                :to="`/subprogramas/${subprogram.slug}`"
                >Conoce más</Button
              >
            </li>
          </List> -->
          <table>
            <tbody>
              <tr
                v-for="(subprogram, index) in subprograms"
                :key="index"
                class="program"
              >
                <td>
                  <h5 class="program__title">
                    <Icon svg="doubleAngleRight" />{{ subprogram.title }}
                  </h5>
                </td>
                <td>
                  <Button
                    tag="router-link"
                    theme="inverted"
                    :to="`/subprogramas/${subprogram.slug}`"
                    >Conoce más</Button
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </ContentR>
      </div>
    </ContainerLR>
  </section>
</template>
<script>
import Container from "@/components/ui/objects/Container.vue";
import ContainerLR from "@/components/ui/objects/ContainerLR.vue";
import ContentL from "@/components/ui/molecules/ContentL.vue";
import ContentR from "@/components/ui/molecules/ContentR.vue";
import Button from "@/components/ui/atoms/Button";
import Icon from "@/components/ui/atoms/Icon.vue";
export default {
  components: {
    Container,
    ContainerLR,
    ContentR,
    ContentL,
    Button,
    Icon
  },
  props: {
    subprograms: {
      type: Array,
      default: () => []
    }
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.subprograms {
  background-color: variables.$background-dark-color;
  color: variables.$text-inverted-color;
  padding: variables.$spacing-l 0;
  .program {
    &__title {
      margin: 0;
      padding-top: 0.6em;
      padding-bottom: 0.6em;
    }
    .btn {
      margin-left: 1em;
    }
  }
}
</style>
